<template>
  <div>
    <b-form @submit.prevent>
      <b-row>
        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold">Email :</span><a :href="'/accounts/'+this.$route.params.email"><span style="font-weight: bold;padding-bottom: 10px"> {{ this.$route.params.email }} </span></a>
          </div>
        </b-col>

        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold;padding-bottom: 10px">ID : {{ this.$route.params.device }} </span>
          </div>
        </b-col>

        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold;padding-bottom: 10px">Mobile : {{ device.mobile }} </span>
          </div>
        </b-col>

        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold;padding-bottom: 10px">OS Version : {{ device.osVersion }} </span>
          </div>
        </b-col>

        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold;padding-bottom: 10px">Platform : {{ device.platform }} </span>
          </div>
        </b-col>

        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold;padding-bottom: 10px">Type : {{ device.type }} </span>
          </div>
        </b-col>

        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold;padding-bottom: 10px">Created At: {{ device.created }}</span>  ,  Last Update: {{ device.updated }}
          </div>
        </b-col>

        <b-col cols="12">
          <b-form-group>
            <b-form-checkbox
              id="accountEnabled"
              v-model="device.status"
              name="accountEnabled"
              value="ENABLED"
              unchecked-value="DISABLED"
            >
              Enabled (Devices status)
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <!-- reset and submit -->
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="saveDevice"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import {
  BRow, BCol, BFormGroup, BFormCheckbox, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      device: {},
    }
  },
  mounted() {
    const deviceId = window.btoa(`${this.$route.params.email}/${this.$route.params.device}`)
    const url = `${this.$readerURL}/admin/devices/${deviceId}`
    this.loader('block')
    firebase.auth().currentUser.getIdToken(false).then(idToken => {
      axios.get(url,
        {
          headers: {
            Authorization: idToken,
          },
        }).then(response => {
        this.device = response.data
        this.loader('none')
        return response
      }).catch(error => {
        console.log(error)
        this.loader('none')
        this.$bvModal
          .msgBoxOk(`Device not found: ${error}`, {
            title: 'Info',
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Close',
            hideHeaderClose: false,
            centered: true,
          })
          .then(value => {
            console.log(value)
            this.$router.push('/devices')
          })
      })
    })
  },
  methods: {
    saveDevice() {
      const deviceId = window.btoa(`${this.$route.params.email}/${this.$route.params.device}`)
      const url = `${this.$readerURL}/admin/devices/${deviceId}`
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, this.device,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          console.log(error)
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
  },
}
</script>
